/** Format an ISO timestamp in Central Time, e.g. "Nov 4, 2026, 12:08 PM CT". */
const FMT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago',
  month: 'short', day: 'numeric', year: 'numeric',
  hour: 'numeric', minute: '2-digit', hour12: true,
})

export function formatCentralTime(iso: string | Date | null | undefined): string {
  if (iso == null) return ''
  const d = iso instanceof Date ? iso : new Date(iso)
  if (!Number.isFinite(d.getTime())) return ''
  // Some ICU builds use a narrow no-break space before AM/PM; normalize it.
  return `${FMT.format(d).replace(/[\u202f\u00a0]/g, ' ')} CT`
}
